import styled from 'styled-components'

/*
 * Everything above a list's rows, in one fixed shape:
 *
 *   ┌───────────────────────────────────────────┬──────────┐
 *   │ cards    filter cards                     │ actions  │
 *   │ filters  search · pickers …   month filter│          │
 *   │ tags     picked group filters             │          │
 *   └───────────────────────────────────────────┴──────────┘
 *
 * Each left row shows only when it has something in it; the actions (the New
 * button, a step's Next) always sit at the top right, whichever rows there are.
 */

const Bar = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    width: 100%;
    padding-bottom: 0.5rem;
`

const Left = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
`

const TagsRow = styled.div`
    margin-bottom: 0.5rem;
`

// Level with the first row: top-aligned with the filter cards (as far down as
// they are), or else centred on the search row (0.5rem down, 42px tall).
const Actions = styled.div`
    flex: none;
    display: flex;
    align-items: ${({ $cardsTop }) => $cardsTop ? 'flex-start' : 'center'};
    gap: 0.5rem;
    margin-top: ${({ $cardsTop }) => $cardsTop ?? '0.5rem'};
    min-height: ${({ $cardsTop }) => $cardsTop ? 'auto' : '42px'};
`

// `cardsTop`: how far down the filter cards start (their filters.marginTop).
const ListTopBar = ({ cards, cardsTop = '0.5rem', filters, tags, actions }) => {
    const hasActions = Array.isArray(actions) ? actions.some(Boolean) : !!actions

    return (
        <Bar>
            <Left>
                {cards}
                {filters}
                {tags && <TagsRow>{tags}</TagsRow>}
            </Left>
            {hasActions && <Actions $cardsTop={cards ? cardsTop : undefined}>{actions}</Actions>}
        </Bar>
    )
}

export default ListTopBar
